const action = {
  USER_ONBOARD: 'USER_ONBOARD',
  USER_ADD: 'USER_ADD',
  USER_UPDATE:'USER_UPDATE',
  USER_API_SUCCESS:'USER_API_SUCCESS',
  USER_LIST:'USER_LIST',
  INVESTER_LIST:'INVESTER_LIST',
  USER_FETCH_ID:'USER_FETCH_ID',
  USER_FETCH_LIST_ID:'USER_FETCH_LIST_ID',
  CDD_LIST: 'CDD_LIST',
  CDD_BULK_UPDATE: 'CDD_BULK_UPDATE',
  COMP_CDD_LIST : 'COMP_CDD_LIST',
  USER_COMP_API_SUCCESS:'USER_COMP_API_SUCCESS',
   userAdd:(history, dataObj,redirectKey) => ({ //Action creator function
     type: action.USER_ADD, //Action
    payload: { history, dataObj,redirectKey } //pass payload to action, we should pass as little data to action
  }),
  userOnboard:( dataObj) => ({ //Action creator function
     type: action.USER_ONBOARD, //Action
   payload: { dataObj } //pass payload to action, we should pass as little data to action
 }),
userList:(readFilter, page) => ({ //Action creator function
  type: action.USER_LIST, //Action
  payload: { readFilter,page } //pass payload to action, we should pass as little data to action
}),
  useraApiSuccess: (data, message,success) => ({
    type: action.USER_API_SUCCESS,
    data,
      message,
      success
  }),
  userUpdate:(history, dataObj,redirectKey) => ({ //Action creator function
    type: action.USER_UPDATE, //Action
   payload: {history, dataObj,redirectKey } //pass payload to action, we should pass as little data to action
 }),
 investerList:( readFilter, page) => ({ //Action creator function
  type: action.INVESTER_LIST, //Action
  payload: { readFilter,page } //pass payload to action, we should pass as little data to action
}),
userfetchBYId:(listid)=>({
  type: action.USER_FETCH_ID,
  payload:{listid}
}),
userListById: (data,message,success) => ({
 type: action.USER_FETCH_LIST_ID,
 data,
 message,
 success
}),
cddList:( readFilter, page) => ({ //Action creator function
  type: action.CDD_LIST, //Action
  payload: { readFilter,page } //pass payload to action, we should pass as little data to action
}),
cddBulkUpdate: (history, userPojo) => ({
  type: action.CDD_BULK_UPDATE,
  payload: { history, userPojo }
}),
compCddList:( readFilter, page) => ({ //Action creator function
  type: action.COMP_CDD_LIST, //Action
  payload: { readFilter,page } //pass payload to action, we should pass as little data to action
}),
compUserApiSuccess: (data, message,success) => ({
  type: action.USER_COMP_API_SUCCESS,
  data,
    message,
    success
}),
   
};
export default action;
  